import Authorized from './Authorized';
import check from './checkPermissions';

Authorized.check = check;

export default Authorized;
